// extracted by mini-css-extract-plugin
module.exports = {"locations":"_65b6daa2"};